import { render, staticRenderFns } from "./pemilikSaham.vue?vue&type=template&id=7d47b07d&"
import script from "./pemilikSaham.vue?vue&type=script&lang=js&"
export * from "./pemilikSaham.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports